import { Component } from '@angular/core';
import { PasswordResetForm } from './password-reset.form';
import { AbstractFormComponent } from '../../../shared/crud/component/form.component';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'session-login',
  templateUrl: './password-reset.component.html',
  styleUrls: [ './password-reset.component.scss' ]
})
export class PasswordResetComponent extends AbstractFormComponent {

  constructor(form: PasswordResetForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute) {
    super(form, httpClient, toastrService, router, route);
  }

  getUrl(): string {
    return '/password/reset';
  }

  onSubmit(): void {
    this.toastrService.success('You will receive mail with link to reset the password');
  }
}
